// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import 'url-search-params-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Datepicker from 'vuejs-datepicker'
import { ko } from 'vuejs-datepicker/dist/locale'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

Vue.component('datepicker', Datepicker)

Vue.use(ko)
Vue.use(Vuex)
Vue.use(VueAxios, axios)

Vue.config.productionTip = false
Vue.prototype.language = ko

axios.defaults.withCredentials = true
axios.defaults.xsrfCookieName = 'csrf_cookie_name'
axios.defaults.xsrfHeaderName = 'X-CSRF-TOKEN'

const CSRF_COOKIE = 'csrf_cookie_name'
let csrfToken = null

function readCsrfCookie () {
  const match = document.cookie.match(/(?:^|;\s*)csrf_cookie_name=([^;]*)/)
  if (!match) {
    return null
  }
  try {
    return decodeURIComponent(match[1])
  } catch (e) {
    return match[1]
  }
}

function setCsrfToken (token) {
  if (token) {
    csrfToken = token
  }
}

function getCsrfToken () {
  return csrfToken || readCsrfCookie() || Vue.$cookies.get(CSRF_COOKIE) || null
}

Vue.prototype.$setCsrfToken = setCsrfToken
Vue.prototype.$getCsrfToken = getCsrfToken

axios.interceptors.request.use((config) => {
  const token = getCsrfToken()
  if (token) {
    config.headers['X-CSRF-TOKEN'] = token
  }
  return config
})

const mountApp = () => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    components: {
      App
    },
    template: '<App/>'
  })
}

// Prime CSRF cookie + in-memory hash, then always mount (never block the UI)
function primeCsrf () {
  return axios.get('/api/member/csrf')
    .then(({ data }) => {
      if (data && data.csrfHash) {
        setCsrfToken(data.csrfHash)
      } else {
        setCsrfToken(readCsrfCookie())
      }
    })
    .catch(() => {
      setCsrfToken(readCsrfCookie())
    })
}

primeCsrf().then(mountApp, mountApp)



// WEBPACK FOOTER //
// ./src/main.js